/**
 * Created by JIocb on 22.05.2017.
 */
namespace Factive.Game {
    export enum ScoreCombinationType
    {
        Ones,
        Twos,
        Threes,
        Fours,
        Fives,
        Sixes,
        TheSame3Kind,
        TheSame4Kind,
        TheSame5Kind,
        FullHouse,
        SmallStraight,
        Straight,
        Chance
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/Scoring/ScoreCombinationType.ts